export { default } from './IntersectionObserver';
export { parseRootMargin } from './utils';
export * from './hook';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@researchgate/react-intersection-list/node_modules/@researchgate/react-intersection-observer/lib/es/index.js
// module id = VuSO
// module chunks = 7 8 9 10 11 12 13